import React, { useState } from "react";
import { LANDING } from "../constants/testIds/landing";
import { Menu, X, Globe } from "lucide-react";

export const Navigation = ({ lang, setLang, t, onOpenImpressum, onOpenDatenschutz }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { name: t.nav.home, href: "#home", testId: LANDING.navLinkHome },
    { name: t.nav.philosophy, href: "#philosophy", testId: LANDING.navLinkPhilosophy },
    { name: t.nav.book, href: "#book", testId: LANDING.navLinkBook },
    { name: t.nav.contact, href: "#contact", testId: LANDING.navLinkContact },
  ];

  const toggleLang = (targetLang) => {
    if (lang !== targetLang) {
      setLang(targetLang);
    }
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#efe7dd]/85 border-b border-[#b58e70]/30 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-20 sm:h-24">
          {/* Logo / Brand */}
          <a
            href="#home"
            data-testid={LANDING.navLogo}
            className="group flex items-center mr-6 shrink-0"
          >
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.jpg`}
              alt="Entre Amigos Tango Argentino"
              className="h-14 sm:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
            />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8 lg:space-x-12">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={item.testId}
                className="font-sans text-xs tracking-[0.2em] uppercase text-[#5a4b46] hover:text-[#1c110e] active:text-[#d97036] transition-colors duration-300"
              >
                {item.name}
              </a>
            ))}
            
            <button
              onClick={onOpenImpressum}
              data-testid={LANDING.impressumLink}
              className="font-sans text-xs tracking-[0.2em] uppercase text-[#5a4b46] hover:text-[#1c110e] transition-colors duration-300"
            >
              {t.nav.impressum}
            </button>
            <button
              onClick={onOpenDatenschutz}
              data-testid={LANDING.datenschutzLink}
              className="font-sans text-xs tracking-[0.2em] uppercase text-[#5a4b46] hover:text-[#1c110e] transition-colors duration-300"
            >
              {t.nav.datenschutz}
            </button>
          </nav>

          {/* Language Toggle & Mobile Menu Btn */}
          <div className="flex items-center space-x-6 sm:space-x-8">
            {/* Elegant Language Selector */}
            <div className="flex items-center bg-[#e5d8cb] px-3 py-1.5 border border-[#b58e70]/30">
              <Globe className="w-3.5 h-3.5 text-[#b58e70] mr-2" />
              <button
                onClick={() => toggleLang("en")}
                data-testid={LANDING.langToggleEn}
                className={`font-sans text-xs tracking-wider uppercase font-medium px-2 py-0.5 transition-colors duration-300 ${
                  lang === "en" ? "text-[#d97036] bg-[#8a2424]/10" : "text-[#5a4b46] hover:text-[#1c110e]"
                }`}
              >
                EN
              </button>
              <span className="text-[#b58e70]/40 text-xs px-1">|</span>
              <button
                onClick={() => toggleLang("de")}
                data-testid={LANDING.langToggleDe}
                className={`font-sans text-xs tracking-wider uppercase font-medium px-2 py-0.5 transition-colors duration-300 ${
                  lang === "de" ? "text-[#d97036] bg-[#8a2424]/10" : "text-[#5a4b46] hover:text-[#1c110e]"
                }`}
              >
                DE
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-[#1c110e] hover:text-[#d97036] transition-colors p-1"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-[#e5d8cb]/95 border-b border-[#b58e70]/30 backdrop-blur-lg animate-fadeIn">
          <div className="px-6 py-6 space-y-4">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileMenuOpen(false)}
                data-testid={item.testId}
                className="block font-sans text-sm tracking-[0.2em] uppercase text-[#5a4b46] hover:text-[#1c110e] py-2 border-b border-[#b58e70]/10"
              >
                {item.name}
              </a>
            ))}
            <button
              onClick={() => {
                setMobileMenuOpen(false);
                onOpenImpressum();
              }}
              data-testid={LANDING.impressumLink}
              className="block w-full text-left font-sans text-sm tracking-[0.2em] uppercase text-[#5a4b46] hover:text-[#1c110e] py-2 border-b border-[#b58e70]/10"
            >
              {t.nav.impressum}
            </button>
            <button
              onClick={() => {
                setMobileMenuOpen(false);
                onOpenDatenschutz();
              }}
              data-testid={LANDING.datenschutzLink}
              className="block w-full text-left font-sans text-sm tracking-[0.2em] uppercase text-[#5a4b46] hover:text-[#1c110e] py-2 border-b border-[#b58e70]/10"
            >
              {t.nav.datenschutz}
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
